<template>
  <div>
    <div class="field is-horizontal" v-for="p in externalProfiles" :key="p.profileName">
      <div class="field-body">
        <text-field :label="p.label" :placeholder="p.placeholder" v-model="p.profileValue" />
      </div>
    </div>
  </div>
</template>

<script>
import Field from '@/components/general/field'
import TextField from '@/components/general/text-field'
import { mapGetters, mapActions } from 'vuex'
import mergeWith from 'lodash/mergeWith'

export default {
  data () {
    return {
      externalProfiles: [
        { label: this.$t('profile.portfolioOrWebsite'), placeholder: 'URL', profileName: 'website', profileValue: '' },
        { label: 'CodePen', placeholder: 'Username', profileName: 'codepen', profileValue: '' },
        { label: 'Dribbble', placeholder: 'Username', profileName: 'dribbble', profileValue: '' },
        { label: 'GitHub', placeholder: 'Username', profileName: 'github', profileValue: '' },
        { label: 'LinkedIn', placeholder: 'Username', profileName: 'linkedin', profileValue: '' },
        { label: 'Medium', placeholder: 'Username', profileName: 'medium', profileValue: '' },
        { label: 'Stack Overflow', placeholder: 'Username', profileName: 'stackoverflow', profileValue: '' },
        { label: 'Twitter', placeholder: 'Username', profileName: 'twitter', profileValue: '' }
      ]
    }
  },
  components: { Field, TextField },
  computed: {
    ...mapGetters('users', ['profiles', 'userid'])
  },
  async mounted () {
    await this.getUserProfiles(this.userid)
    this.externalProfiles = mergeWith(this.externalProfiles, this.profiles)
  },
  methods: {
    ...mapActions('users', ['getUserProfiles'])
  },
  watch: {
    externalProfiles: {
      deep: true,
      handler: function (newVal) {
        this.$store.commit('users/setSocialProfiles', newVal)
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/profile/profiles/social-profiles-form.vue